import React, { Component, useRef, useState} from 'react';
import CatTree from './CatTree';
import CoursePane from './course/CoursePane';
import RootPane from './root/RootPane';
import TopicPane from './topic/TopicPane';
import OutcomePane from './outcome/OutcomePane';
import SkillPane from './skill/SkillPane';
import CompPane from './comp/CompPane';
import CatService from '../../service/CatService';
import { Messages } from 'primereact/messages';
import { useTranslation } from 'react-i18next';

function Curriculum(props){
  const {t} = useTranslation();
  const messages = useRef(null);
  const [cat,setCat] = useState({ id: 0, name: '', code: '', path: '' });
  const [catAction,setCatAction] = useState(null);

  const selectionChanged = (selectedCat)=>{
    CatService.getCatChain(selectedCat.id).then((ret)=>{
      selectedCat.parents = ret;
      setCat(selectedCat);
    }).catch((err)=>{
      console.log(err);
      showError(err.message);
    });
  }
  const catAdded = (cat)=>{
    setCatAction({method:'ADD',cat:cat});
  }
  const catChanged = (cat)=>{
    console.log('Curriculum:catChanged');
    setCatAction({method:'MODIFY',cat:cat});
  }
  const catDeleted = (cat)=>{
    setCatAction({method:'DELETE',cat:cat});
  }
  const showError=(msg)=>{
    messages.current.show([
      {sticky: false, severity: 'error', summary: t('error'), detail: t("error."+msg), closable: true}]);
  }
  const refresh = ()=>{
    setCatAction({method:'REFRESH'});
  }
  var catPane = "";
  if (cat.catType == 'COURSE')
    catPane = <CoursePane cat={cat} catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} selectionChanged={selectionChanged}/>;
  else if (cat.catType == 'ROOT')
    catPane = <RootPane cat={cat} catAdded={catAdded} catChanged={catChanged} 
      catDeleted={catDeleted} selectionChanged={selectionChanged} refresh={refresh}/>;
  else if (cat.catType == 'TOPIC')
    catPane = <TopicPane cat={cat} catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} selectionChanged={selectionChanged}/>;
  else if (cat.catType == 'OUTCOME')
    catPane = <OutcomePane cat={cat} catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} selectionChanged={selectionChanged}/>;
  else if (cat.catType == 'COMP')
    catPane = <CompPane cat={cat} catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} selectionChanged={selectionChanged}/>;
  else if (cat.catType == 'SKILL')
    catPane = <SkillPane cat={cat} catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} selectionChanged={selectionChanged}/>;

  return (
    <>
    <div className="grid">
      <div className="col-12"><Messages ref={messages}/></div>
      <div className="col-12 md:col-4 flex flex-column">
        <div className="card flex-1 overflow-auto" style={{maxHeight:'80vh'}}>
          <h5>{t('Curriculum')}</h5>
          <CatTree onSelect={selectionChanged} showError={showError} catAction={catAction}/>
       </div>
      </div>
      <div className="col-12 md:col-8 flex flex-column">
        <div className='card flex-1 overflow-hidden' style={{maxHeight:'80vh'}}>
        {catPane}
        </div>
      </div>
    </div >
    </>    
  )
}
export default Curriculum;
